<div class="flex flex-col h-full">
  <mat-toolbar class="bg-white h-9" style="padding: 0" *ngIf="isLoggedIn$ | async">
    <div
      id="container"
      [class.py-2]="
        (showMainNav$$.asObservable() | async) || (showIcon$.asObservable() | async) || (title$.asObservable() | async)
      "
      class="flex justify-between overflow-x-auto"
      style="width: 100vw"
    >
      <div
        class="flex justify-center relative items-center"
        style="width: 100vw"
        *ngIf="(showMainNav$$.asObservable() | async) === false"
      >
        <span
          class="absolute left-0 material-icons text-lg self-center p-1 cursor-pointer"
          (click)="navigationAction()"
          *ngIf="showIcon$.asObservable() | async"
          >{{ icon$.asObservable() | async }}</span
        >
        <span>{{ title$.asObservable() | async }}</span>
      </div>

      <div class="flex justify-between" style="width: 100vw" *ngIf="showMainNav$$.asObservable() | async">
        <div class="flex-1 flex flex-row col-gap-1 px-3">
          <a [routerLink]="['/work-orders']" class="self-center" style="min-width: 30px">
            <img src="assets/images/nav.png" class="h-4" alt="loma logo" />
          </a>
          <span class="self-center font-bold tracking-widest">LOHI</span>
        </div>
        <div class="headers">
          <div class="headers-item item1" routerLink="/work-orders">Work Orders</div>
          <div class="headers-item item2" routerLink="/assets">Assets</div>
          <div class="headers-item item3" routerLink="/sites">Sites</div>
        </div>

        <div class="flex flex-row" [matMenuTriggerFor]="userMenu">
          <div class="profile-box">
            <div class="rounded-full bg-gray-400 w-5 h-5 flex justify-center items-center self-center">
              <mat-icon>account_circle</mat-icon>
            </div>
            <span class="material-icons text-lg self-center p-1">keyboard_arrow_down</span>

            <mat-menu #userMenu="matMenu" class="px-3 bg-white">
              <button class="text-gray-600 text-sm p-0 font-bold" style="padding: 0" (click)="logout()" mat-menu-item>
                Logout
              </button>
            </mat-menu>
          </div>
        </div>
      </div>
    </div>
  </mat-toolbar>

  <!--  <mat-sidenav-container class="h-full">-->
  <!--    <mat-sidenav #sidenav [mode]="'over'" class="w-35 bg-white border-none" [autoFocus]="false">-->
  <!--      <lam-menu (closeMenu)="sidenav.close()"></lam-menu>-->
  <!--    </mat-sidenav>-->
  <!--    <mat-sidenav-content>-->
  <div class="flex flex-col h-full">
    <div class="flex-1">
      <router-outlet></router-outlet>
    </div>
  </div>
  <!--    </mat-sidenav-content>-->
  <!--  </mat-sidenav-container>-->
</div>
